/**
 * Adding a page Id?
 * @see https://backstage.spotify.net/docs/mrkt-web/logging/page-events/#adding-a-new-page
 */
export enum PageId {
  AddArtistConfirm = 'mrkt/add-artist/confirm',
  AddArtistSearch = 'mrkt/add-artist/search',
  ArtistAudience = 'mrkt/artist/audience',
  ArtistContentMismatch = 'mrkt/content-mismatch',
  ArtistDistributorInvite = 'mrkt/distributor-invite',
  ArtistHome = 'mrkt/artist/home',
  ArtistLabs = 'mrkt/labs',
  ArtistLabsArtistHistory = 'mrkt/labs/artist-history',
  ArtistMusic = 'mrkt/artist/music',
  ArtistNMS = 'mrkt/artist/nms',
  ArtistNMSCreate = 'mrkt/artist/nms/create',
  ArtistNMSEdit = 'mrkt/artist/nms/edit',
  ArtistPlaylists = 'mrkt/artist/playlists',
  ArtistProfile = 'mrkt/artist/profile',
  ArtistProfileAbout = 'mrkt/artist/profile/about',
  ArtistProfileConcerts = 'mrkt/artist/profile/concerts',
  ArtistProfileFundraising = '/mrkt/artist/profile/fundraising',
  ArtistProfileImagesEdit = 'mrkt/artist/profile/images/edit',
  ArtistProfilePlaylists = 'mrkt/artist/profile/playlists',
  ArtistReleases = 'mrkt/artist/releases',
  ArtistSongCities = 'mrkt/artist/song/cities',
  ArtistSongCountries = 'mrkt/artist/song/countries',
  ArtistSongPlaylists = 'mrkt/artist/song/playlists',
  ArtistSongStats = 'mrkt/artist/song/stats',
  ArtistSongs = 'mrkt/artist/songs',
  ArtistUpcoming = 'mrkt/artist/upcoming',
  ArtistCampaigns = 'mrkt/artist/campaigns',
  ArtistCampaignsTeam = 'mrkt/artist/campaigns/team',
  ArtistCampaignsPreview = 'mrkt/artist/campaigns/preview',
  ArtistCampaignsBudget = 'mrkt/artist/campaigns/budget',
  ArtistCampaignsReview = 'mrkt/artist/campaigns/review',
  ArtistCampaignsSuccess = 'mrkt/artist/campaigns/success',
  ArtistCampaignsDetail = 'mrkt/artist/campaigns/detail',
  ArtistCampaignAdmin = 'mrkt/artist/campaign-admin',
  NotFound = 'mrkt/not-found',
  Roster = 'mrkt/roster',
  TeamLabelArtists = 'mrkt/team/label/artists',
  TeamManagement = 'mrkt/team-management',
  TeamManagementAcceptInvite = 'mrkt/team-management/accept-invite',
  TeamManagementDetails = 'mrkt/team-management/details',
  TeamManagementInvite = 'mrkt/team-management/invite',
  UserSettings = 'mrkt/user-settings',
}
